export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13.25 7.25c0 .6904-.5596 1.25-1.25 1.25s-1.25-.5596-1.25-1.25S11.3096 6 12 6s1.25.5596 1.25 1.25zM11 18v-8h2v8h-2z" } }];
export const iconName = 'information';
export const information = { iconName, paths };
export default paths;
